// src/onboarding/OnbFrame.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).
//
// Frame wrapper — sky + clouds + ground + rail. Used by every new screen.
// Phase 31.3 Gap 2 — `butterflies` prop opt-in for the Welcome hero alternative.
// Phase 31.3 Gap 4B — detects prefers-color-scheme:dark once per render and
// branches sky + ground palettes so dark-mode text tokens don't collide with
// a hardcoded light sky.

import { useState, useEffect } from 'react';
import OnbClouds from './OnbClouds.jsx';
import OnbGround from './OnbGround.jsx';
import OnbBee from './OnbBee.jsx';
import OnbButterfly from './OnbButterfly.jsx';
import OnbProgressRail from './OnbProgressRail.jsx';
import { ONB_SKIES, ONB_SKIES_DARK } from './constants.js';

export default function OnbFrame({ step, total, ground = "dawn", bees = false, butterflies = false, children, bgExtra }) {
  // Subscribe to prefers-color-scheme changes so the onboarding sky/ground
  // re-render without a page reload. Matches the pattern used elsewhere in
  // the app for dark-mode detection.
  const [isDark, setIsDark] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
      : false
  );
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => setIsDark(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else if (mq.addListener) mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else if (mq.removeListener) mq.removeListener(handler);
    };
  }, []);
  const skyArray = isDark ? ONB_SKIES_DARK : ONB_SKIES;
  const sky = skyArray[step] || skyArray[0];
  return (
    <div className="onb-stage" style={{ "--sky-from": sky.from, "--sky-to": sky.to }}>
      <div className="onb-sky"/>
      <OnbClouds density={2} top={60}/>
      {bees && <OnbBee top={130} delay={0}/>}
      <OnbGround variant={ground} darkMode={isDark}/>
      {bgExtra}
      <OnbProgressRail step={step} total={total}/>
      {children}
      {butterflies && (
        <>
          {/* Both butterflies orbit the right half of the card above the h1 —
              bounds keep them from crossing over the title body; only the
              downward stop grazes the cap-line. Different durations give a
              natural "fluttering together at independent speeds" feel. */}
          <OnbButterfly top={55}  left="62%" delay={0}   palette="amber" duration={14}/>
          <OnbButterfly top={100} left="78%" delay={2.5} palette="lilac" duration={19} scale={0.7}/>
        </>
      )}
    </div>
  );
}
